class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this.swiperContainers = null;
    this.swiperWrappers = null;

    this.thumbSwiper = null;
    this.thumbSwiperInstance = null;
    this.mainSwiper = null;
    this.mainSwiperInstance = null;
  }

  connectedCallback() {
    this.swiperContainers = this.querySelectorAll('.swiper');
    this.swiperWrappers = this.querySelectorAll('.swiper-wrapper');

    // Validate initial setup
    if (
      !this.swiperContainers ||
      this.swiperContainers.length !== 2 ||
      !this.swiperWrappers ||
      this.swiperWrappers.length !== 2
    ) {
      // console.error('ProductGallery requires two swiper containers and two swiper wrappers.');
      return;
    }

    this.thumbSwiper = this.querySelector('.js-swiper--thumb');
    if (!this.thumbSwiper) {
      // console.error('ProductGallery requires thumb swiper wrapper.');
      return;
    }

    this.thumbSwiperInstance = new Swiper(this.thumbSwiper, {
      speed: 400,
      slidesPerView: 4,
      spaceBetween: 16,
      direction: ProductGallery.getDirection(),
      freeMode: true,
      watchSlidesProgress: true,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        resize: () => {
          this.thumbSwiperInstance.changeDirection(
            ProductGallery.getDirection(),
          );
        },
      },
    });

    this.mainSwiper = this.querySelector('.js-swiper--main');
    if (!this.mainSwiper) {
      // console.error('ProductGallery requires main swiper wrapper.');
      return;
    }

    this.mainSwiperInstance = new Swiper(this.mainSwiper, {
      spaceBetween: 10,
      allowTouchMove: true,
      thumbs: {
        swiper: this.thumbSwiperInstance,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  static getDirection() {
    const direction = window.innerWidth <= 750 ? 'horizontal' : 'vertical';

    return direction;
  }
}

if (!customElements.get('product-gallery'))
  customElements.define('product-gallery', ProductGallery);
